import React from "react";
import { IAffiliateDashboard } from "./types";
import { dateLabel, portalTime } from "./fees";
import { Notice } from "./style";

export function pendingTierChange(
  affiliate: IAffiliateDashboard["affiliate"],
  now?: string
) {
  const at = portalTime(now);
  return affiliate?.tier_changes?.find(
    (change) =>
      (!change.announced_at || Date.parse(change.announced_at) <= at) &&
      Date.parse(change.effective_at) > at &&
      (!change.cancelled_at || Date.parse(change.cancelled_at) > at)
  );
}

export const canEditPricing = (
  affiliate: NonNullable<IAffiliateDashboard["affiliate"]>,
  now?: string
) => !affiliate.terminated_at && !pendingTierChange(affiliate, now);

export function AffiliateStatus({
  affiliate,
  now,
}: {
  affiliate: NonNullable<IAffiliateDashboard["affiliate"]>;
  now?: string;
}) {
  if (affiliate.terminated_at)
    return (
      <Notice role="status">
        Affiliate activity ended on {dateLabel(affiliate.terminated_at)}. New
        commissions, referral signups and points spending have stopped. Unused
        points and zero-fee budgets are frozen. Previously earned cash remains
        payable after its holdback; linked traders return to standard fees after
        seven days.
      </Notice>
    );
  const pending = pendingTierChange(affiliate, now);
  if (!pending) return null;
  return (
    <Notice role="status">
      Your tier changes to {pending.tier} on {dateLabel(pending.effective_at)}.
      The new commission share and minimum fees begin then. Rates below the new
      minimum will increase on that date. New codes and pricing edits are locked
      until the change takes effect.
    </Notice>
  );
}
